<template>
  <SmallHeaderBarPage :career="questionFallback!==true" />
  <div class="static-header static-header-career">
    <div class="static-career-header-static-content">
      <img class="static-career-header-static-main-logo" :src="getImage('logo_bunt.svg')" alt="" />
      <h3 class="static-career-header-static-main-text" v-if="text" v-html="formatText" />
      <h3 class="static-career-header-static-main-text" v-else>
        Die <span class="medau">Medau</span>-Unternehmensgruppe besteht aus verschiedenen Unternehmen, in denen
        wir verschiedenste Berufsgruppen beschäftigen. Sag uns, wie wir Dich kontaktieren können, um eine
        mögliche gemeinsame Zukunft auszuloten!
      </h3>
    </div>
    <div v-html="getSVG('arrowLeft')" class="static-header-back" @click="$router.go(-1)" />
  </div>
</template>

<script>
import SmallHeaderBarPage from "@/components/static/SmallHeaderBarPage.vue";

export default {
  data() {
    return {
      text: null,
    }
  },
  props: [
    "questionFallback",
  ],
  components: {
    SmallHeaderBarPage,
  },
  computed: {
    formatText() {
      return this.text.replace(/medau/ig, '<span class="medau">Medau</span>');
    }
  },
  methods: {
    loadText() {
      this.apiRequest('/karriere-header-text')
          .then(cnt => {
            this.text = cnt?.data?.attributes?.Inhalt;
          })
          .catch(() => this.text = false);
    }
  },
  mounted() {
    this.loadText();
  }
}
</script>
